export const userProfile = {
  forgottenPassword: {
    passwordResetEmailSent:
      'Un e-mail de réinitialisation du mot de passe a été envoyé à son adresse e-mail.',
  },
};
